import React, { useState } from "react";
import { Tabs } from "antd";
import { LevelsPanel } from "./LevelsPanel";
import { RulesPanel } from "./RulesPanel";
import { AssignmentsPanel } from "./AssignmentsPanel";

export function SettingsTab({ users }) {
  const [activeKey, setActiveKey] = useState("levels");

  return (
    <Tabs
      activeKey={activeKey}
      onChange={setActiveKey}
      size="small"
      items={[
        { key: "levels", label: "Approval Levels", children: <LevelsPanel /> },
        { key: "rules", label: "Approval Rules", children: <RulesPanel /> },
        { key: "assignments", label: "User Assignments", children: <AssignmentsPanel users={users} /> },
      ]}
    />
  );
}
